import styled from 'styled-components'
import {mediumGray, darkGray} from '@modifi/colors'

export const Th = styled.th`
  height: 80px;
  padding: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  text-align: ${({align}) => align || 'left'};
`

export const FilterTh = styled(Th)`
  padding: 5px;
  font-size: 16px;
  text-align: ${({align}) => align || 'left'};
`

export const Td = styled.td`
  height: 80px;
  padding: 20px;
  font-size: 12px;
  text-align: ${({align}) => align || 'left'};
`

export const Tr = styled.tr`
  > ${Th} {
    border-bottom: 1px solid ${darkGray};
  }

  > ${Td} {
    border-bottom: 1px solid ${mediumGray};
  }

  > th,
  > td {
    &:first-child {
      padding-left: 40px;
    }

    &:last-child {
      padding-right: 40px;
    }
  }

  &:last-child {
    > ${Td} {
      border-bottom: none;
    }
  }
`

export const TdWithWordBreak = styled(Td)`
  word-break: break-all;
`
